import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bodyPart", "checkbox"];

  static values = {
    bodyPart: Array,
    selectedPart: { type: String, default: null },
  };

  connect() {
    // Sync all checked checkboxes to their SVGs
    this.checkboxTargets.forEach((checkbox) => {
      const bodyPartName = checkbox.value;
      const bodyPart = this.bodyPartTargets.find(
        (part) => part.dataset.part === bodyPartName
      );
      if (bodyPart && checkbox.checked) {
        bodyPart.classList.add("selected");
        bodyPart.setAttribute("aria-checked", "true");
      } else if (bodyPart) {
        bodyPart.classList.remove("selected");
        bodyPart.setAttribute("aria-checked", "false");
      }
    });
  }

  onBodyPartKeydown(event) {
    if (!["Enter", " ", "Spacebar"].includes(event.key)) return;

    event.preventDefault();
    this.toggleBodyPart(event.currentTarget);
  }

  onBodyPartClick(event) {
    this.toggleBodyPart(event.currentTarget);
  }

  toggleBodyPart(bodyPart) {
    const bodyPartName = bodyPart.dataset.part;
    const checkbox = this.checkboxTargets.find(
      (cb) => cb.value === bodyPartName
    );
    if (checkbox) {
      // Toggle checked state
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      // Toggle .selected class
      if (checkbox.checked) {
        bodyPart.classList.add("selected");
        bodyPart.setAttribute("aria-checked", "true");
      } else {
        bodyPart.classList.remove("selected");
        bodyPart.setAttribute("aria-checked", "false");
      }
    } else {
      console.warn("Checkbox not found!");
    }
  }
}
